/* src/app/modules/shared/components/image-picker/image-picker.component.scss */
.image-picker img {
  max-width: 100%;
}
.imageButton {
  margin: 16px;
}
.imageButton mat-icon {
  margin-right: 5px;
  margin-bottom: 5px;
}
/*# sourceMappingURL=image-picker.component.css.map */
